export default {
  header: "My Home Page",
  page: "Home",
};
